import { AppInsights } from 'applicationinsights-js';
import { browserHistory } from './history';

export const configureAppInsightsLogging = () => {
    if (process.env.REACT_APP_APPLICATION_INSIGHTS_KEY !== undefined) {
        AppInsights.downloadAndSetup!({
            instrumentationKey: process.env.REACT_APP_APPLICATION_INSIGHTS_KEY
        });

        // Track when pages are changed
        browserHistory.listen(location => {
            AppInsights.trackPageView(location.pathname);
        });
    }
};

export const trackAppInsightsTrace = (message: string, properties?: { [name: string]: string }) => {
    if (process.env.REACT_APP_APPLICATION_INSIGHTS_KEY !== undefined) {
        AppInsights.trackTrace(message, properties, AI.SeverityLevel.Information);
    }
};

export const logAppInsightsException = (errorMessage: string, source: string) => {
    if (process.env.REACT_APP_APPLICATION_INSIGHTS_KEY !== undefined) {
        AppInsights.trackException(
            new Error(errorMessage),
            undefined,
            { source: source },
            undefined,
            AI.SeverityLevel.Error
        );
    }
};



// WEBPACK FOOTER //
// ./src/utilities/logging.ts